module.exports = __webpack_public_path__ + "static/media/coat.d8c28c99.jpg";